// Mirrors Shopify's money_format so JS-rendered prices match the Liquid ones.
// Intl.NumberFormat is not a substitute: it imposes the visitor's browser locale
// and two decimal places, so a store set to no decimals would still show them.
// Port of Shopify's canonical formatMoney.
window.chilloutFormatMoney =
  window.chilloutFormatMoney ||
  function chilloutFormatMoney(cents, format) {
    const amount = typeof cents === 'string' ? Number(cents.replace('.', '')) : cents;
    const formatString = format || '${{amount}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(value, precision = 2, thousands = ',', decimal = '.') {
      if (value == null || Number.isNaN(value)) return '0';

      const fixed = (value / 100).toFixed(precision);
      const [whole, fraction] = fixed.split('.');
      const grouped = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);

      return fraction ? grouped + decimal + fraction : grouped;
    }

    const match = formatString.match(placeholder);
    let value = '';

    switch (match && match[1]) {
      case 'amount':
        value = withDelimiters(amount, 2);
        break;
      case 'amount_no_decimals':
        value = withDelimiters(amount, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(amount, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(amount, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(amount, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(amount, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(amount, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(amount, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(amount, 2);
    }

    return formatString.replace(placeholder, value);
  };
